export default "__VITE_ASSET__Bu0XGe2F__"